import React, { useEffect, useState } from "react";
import { Navigate, PathRouteProps, useLocation } from "react-router-dom";
import { AuthService } from "../../modules/auth/login-service";
import { saveReturnUrl } from "../../modules/auth/return-url";
import ErrorBoundary from "../error/error-boundary";
import { login, setRoles, setUser } from "../reducers/authentication";
import { useAppDispatch } from "../store/store";

interface IOwnProps extends PathRouteProps {
  children: React.ReactNode;
  hasRoles?: string[];
  hasNoRoles?: string[];
}

function rolesAllowed(
  userRoles: string[],
  hasRoles?: string[],
  hasNoRoles?: string[]
) {
  let roleOk = true;
  if (hasRoles && hasRoles.length > 0) {
    roleOk = hasRoles.some((role) => userRoles.includes(role));
  }
  if (hasNoRoles && hasNoRoles.length > 0) {
    roleOk = !hasNoRoles.some((role) => userRoles.includes(role));
  }
  return roleOk;
}

const PrivateRoute = ({ children, hasRoles, hasNoRoles }: IOwnProps) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [checked, setChecked] = useState(false);
  const [isAuthenticated, setAuthenticated] = useState(false);
  const [sessionRoles, setSessionRoles] = useState<string[]>([]);

  useEffect(() => {
    let cancelled = false;
    AuthService.me().then(
      (resp) => {
        if (cancelled) return;
        const roles = resp.data.roles ?? [];
        dispatch(setRoles(roles));
        dispatch(setUser({
          username: resp.data.username,
          name: resp.data.name,
          email: resp.data.email,
        }));
        dispatch(login());
        setSessionRoles(roles);
        setAuthenticated(true);
        setChecked(true);
      },
      () => {
        if (cancelled) return;
        saveReturnUrl(location.pathname + location.search);
        setAuthenticated(false);
        setChecked(true);
      }
    );
    return () => {
      cancelled = true;
    };
  }, [dispatch, location.pathname, location.search]);

  if (!checked) {
    return null;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  if (!rolesAllowed(sessionRoles, hasRoles, hasNoRoles)) {
    return <Navigate to="/home" replace />;
  }
  return <ErrorBoundary>{children}</ErrorBoundary>;
};

export default PrivateRoute;
